import z from 'zod';
import { zContactNumber } from '@acp/shared';

export const occupantSchema = z.object({
    occupantId: z.number().int().positive().optional(),
    name: z.string().min(1, 'Please enter a name').nullable(),
    email: z.coerce
        .string()
        .email({ message: 'Please enter a valid email address' })
        .nullable()
        .or(z.literal('')),
    contactNumbers: z.array(zContactNumber),
});
